export default "__VITE_ASSET__BfuZ7uSm__"